import React from "react";
import Logo from "../assets/verdant-matcha-lab-logo-final.png";
import { Link } from "react-router-dom";
import MenuIcon from "../assets/menu-icon.png";
import "../styles/Navbar.css";


function Navbar() {
    const [openLinks, setOpenLinks] = React.useState(false);

    const toggleNavbar = () => {
        setOpenLinks(!openLinks);
    };
    return (
        <div className="navbar">
            <div className="leftSide" id={openLinks ? "open" : "close"}>
                <img src={Logo} alt="logo"/>
                <div className="hiddenLinks">
                  <Link to="/">Basis</Link>
                  <Link to="/menu">Elixirs</Link>
                  <Link to="/about">Genesis</Link>
                  <Link to="/contact">Dialog</Link>
                </div>     
            </div>
            <div className="rightSide">
                <Link to="/">Basis</Link>
                <Link to="/menu">Elixirs</Link>
                <Link to="/about">Genesis</Link>
                <Link to="/contact">Dialog</Link>
                <button onClick={toggleNavbar}>
                    <img src={MenuIcon} alt="Menu" style={{ width: '30px', height: 'auto' }} />
                </button>
            </div>
        </div>      
    );
}

export default Navbar;